<template>
    <div>
        <div style="text-align: center" v-if="t401">
            <h1>The task is currently Running. Please wait while we are processing the task.</h1>
            <h1>You will need the task ID to query the result, please save it carefully.</h1>
        </div>

        <div style="text-align: center" v-if="t403">
            <h1>The task is currently Queuing. Please wait while we are processing the task.</h1>
            <h1>You will need the task ID to query the result, please save it carefully.</h1>
        </div>

        <div style="text-align: center" v-if="t400">
            <h1>Task submission failed, please check your input.</h1>
        </div>

        <div style="text-align: center" v-if="t402">
            <h1>
                Task ID does not exist, please check your input.
            </h1>
        </div>

        <div class="container" v-if="userInfo">
            <el-descriptions :column="2"  border width="190" >
                <el-descriptions-item  v-for="(value,key) in overview">
                    <template slot="label">
                        {{key}}
                    </template>
                    <div style="white-space: pre;">{{value}}</div>
                </el-descriptions-item>
            </el-descriptions>

<!--            <p>Input Pharmacophore</p>-->

<!--            <div style=" width:400px;white-space: pre;box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;background-color: white">-->
<!--                <div style="margin-left: 5px">{{fileContent}}</div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "TemResult",
        data() {
            return {
                fileContent:'',
                overview:[],
                t400:false,
                t401:false,
                t402:false,
                t403:false,
                userInfo:true,
            }
        },
        created() {
            var sid=this.$route.query.sid
            var that=this

            axios.get("/getinfo",{params:{uuid:sid}}).then(res => {
                console.log("overview")
                console.log(res.data)
                this.fileContent=res.data["Input Pharmacophore"]
                this.overview=res.data
            })

            var st = setInterval(function(){
                axios.get("/search/"+sid).then(res=>{
                    console.log(res.data)
                    if(res.data.code==400)//数据运行失败
                    {
                        that.t400=true
                        that.userInfo=true
                    }
                    if(res.data.code==401)//数据运行中
                    {
                        that.t403=false
                        that.t401=true
                        that.userInfo=true
                    }
                    else if(res.data.code==402)//uid不存在
                    {
                        that.t402=true
                        that.userInfo=true
                        clearInterval(st);

                    }
                    else if(res.data.code==403)//数据排队中
                    {
                        that.t403=true
                        that.userInfo=true
                    }
                    else if(res.data.code==200)//数据运行成功
                    {
                        clearInterval(st);

                        that.t401=false
                        that.userInfo=false

                        that.$router.push({
                            path: '/result',
                            query: {
                                sid: sid
                            }
                        })
                    }
                })

            },1000)
        }
    }

</script>

<style scoped>

</style>